export const TRANSLATIONS_EN = {
  components: {
    header: { text: "Do you have questions?" },
    footer: {
      firstRow: "Cornèr Bank Ltd. ,",
      secondRow: "Via Canova 16, 6901 Lugano - Switzerland",
    },
  },
  screens: {
    common: {
      mr: "Mr",
      mrs: "Mrs",
      haveQuestions: "Do you have questions?",
      back: "Back",
      continue: "Continue",
      change: "Change",
      yes: "Yes",
      no: "No",
      none: "None",
      other: "Other",
      confirm: "Confirm",
      remove: "Remove",
      optional: "optional",
      skipStep: "Skip this step",
      backHome: "Back to Home",
      cancelOnboarding: "Cancel onboarding",
      search: "Search",
      disclaimer: "Disclaimer",
      impressum: "Impressum",
      copyrightAddr: "Tödistrasse 27, CH-8002, Zürich - Switzerland",
      errorDate: "Age admitted from 18 to 65",
      underageBo: "The beneficial owner must be of age.",
      chZipRequired: "Please select a valid postal code.",
      readOnlyMessage:
        "Any incorrect information that cannot be changed on this page should be notified to Cornèrcard.",
      disclaimerLink_prep:
        "https://www.prep.corner.ch/en/disclaimer/onboarding-corner3/index.html",
      disclaimerLink_prod:
        "https://www.corner.ch/en/disclaimer/onboarding-corner3/index.html",
    },
    personalData: {
      pageTitle: "Let’s begin!",
      pageSubtitle:
        "Open your Cornèr3 retirement account in just a few minutes.",
      firstName: "Name",
      lastName: "Surname",
      dataInfo:
        "Enter the data exactly as shown on your identification document.",
      email: "E-mail address",
      phoneNr: "Phone number",
      emailRequired: "Please enter a valid email address",
      phoneRequired: "Only number format please, e.g.: 7812234567",
      gtcAgree:
        "I confirm that I have read the <Disclaimer>disclaimer</Disclaimer> and accept it. Furthermore, I confirm that I meet the <Requirements>requirements for digital product subscription.</Requirements>",
      requirementsModal: {
        title: "Requirements for digital product subscription",
        subTitle: "Digital product subscription is reserved for people who:",
        data1:
          "Are subject to unlimited tax liability in Switzerland and earn income subject to OASI/DI from employment, or self-employment;",
        data2:
          "Know and accept the risks associated with the use of IT systems and/or digital channels, such as websites, online platforms or applications for smartphones made available by Cornèr Bank Ltd. and/or by third parties.",
        understood: "I have understood",
      },
    },
    personalDataAdditional: {
      pageTitle: "Some information about you",
      birthDate: "Date of birth",
      birthCountry: "Country of birth",
      nationality: "Nationality",
      maritalStatus: "Marital status",
      maritalStatusList: {
        married: "Married or other unions",
        divorced: "Divorced",
        widowed: "Widowed",
        unmarried: "Unmarried",
        separated: "Separated",
      },
      avsNumber: "Your OASI number",
      avs: "Your OASI number",
      avsInfo: "<AvsInfo>Where can I find my OASI number?</AvsInfo>",
      avsModal: {
        title: "Where can I find my OASI number?",
        description:
          "Your OASI number, if you live or work in Switzerland, can easily be found on the front of your health insurance card, or can be obtained from the occupational compensation office of your canton of residence.",
        understood: "I have understood",
      },
    },
    address: {
      pageTitle: "Where do you reside?",
      pageSubTitle:
        "Access codes to the digital tools Cornèronline and iCornèr App will be sent to the address provided.",
      country: "Country",
      city: "City",
      zipCode: "Post code",
      street: "Street",
      streetNumber: "Number",
    },
    employmentsDetail: {
      pageTitle: "What is your occupational status?",
      employed: "Employed",
      freelancer: "Self-employed",
      qualification: "Occupation",
      pensionFund: "Are you affiliated to a pension fund (2nd pillar)?",
    },
    informationRecap: {
      pageTitle: "Verify your data!",
      pageSubtitle:
        "Double-check the information entered before proceeding to sign the contract.",
      cta: "Confirm",
      personalData: "Personal and contact information",
      employmentsDetail: "Professional information",
      terms:
        "I confirm that I have read the <Terms>conditions of the product</Terms> and I accept the <GeneralTerms>Bank’s general terms and conditions</GeneralTerms>",
      termsLink_prep:
        "https://www.prep.corner.ch/export/sites/cornerbancaCH/.galleries/pdf/onboarding/CORNER3/374a_DE_Fondazione-di-Previdenza-Corner-Terzo-Pilastro-Regolamento.pdf",
      termsLink_prod:
        "https://www.corner.ch/export/sites/cornerbancaCH/.galleries/pdf/onboarding/CORNER3/374a_DE_Fondazione-di-Previdenza-Corner-Terzo-Pilastro-Regolamento.pdf",
      generalTermsLink_prep:
        "https://www.prep.corner.ch/export/sites/cornerbancaCH/.galleries/pdf/onboarding/1020_EN_Condizioni-contrattuali.pdf",
      generalTermsLink_prod:
        "https://www.corner.ch/export/sites/cornerbancaCH/.galleries/pdf/onboarding/1020_EN_Condizioni-contrattuali.pdf",
      dataChanges:
        "If the information provided changes over time, you are required to inform the Bank immediately in writing.",
      gender: "Title:",
      firstName: "Name:",
      lastName: "Surname:",
      email: "E-mail address:",
      phoneNr: "Phone number:",
      birthDate: "Date of birth:",
      birthCountry: "Country of birth:",
      nationality: "Nationality:",
      maritalStatus: "Marital status:",
      city: "City:",
      zipCode: "Post code:",
      street: "Street:",
      streetNumber: "Number:",
      avs: "Your OASI number:",
      currentPosition: "Occupational status:",
      qualification: "Occupation:",
      pensionFund: "Affiliated to a pension fund?",
    },
    contractView: {
      pageTitle: "Get ready for the digital signature!",
      pageSubtitle:
        "Before proceeding with the digital signature, please download your contract. However, you will be able to visualize it entirely during the video identification process.",
      downloadBtn: "Download your contract",
      btnNext: "Continue",
    },
    videoId: {
      pageTitle: "Sign the contract online",
      pageSubtitle: "Prepare the camera and an identification document.",
      mobileSubtitle:
        "Download the video identification app and follow the instructions.<br/><br/>Your ID code is:<br/> <b><TICKET></b>",
      singBtn: "Sign now",
      asset:
        "Digital signature is performed by video identification with smartphones, tablets or desktops by our partner Intrum.",
    },
    videoIdUnavailable: {
      pageTitle: "Oops! <br/> No operator available at this time",
      pageSubtitle:
        "Unfortunately, we cannot confirm your identity because there are no operators available at this time. However, we have sent you an <b>e-mail with the times and the link</b> to resume the video identification later.<br/><br/>Thank you for your understanding!",
      backBtn: "Close",
    },
    successVideoId: {
      pageTitle: "Perfect!",
      pageSubtitle:
        "Your identity has been confirmed.<br/> We will contact you in the next few days.",
      backBtn: "Go to website",
    },
    errors: {
      genericError: {
        title: "An error has occurred",
        subtitle:
          "Oops, something went wrong.<br/><br/>Please try again<br><br>",
        retry: "Retry",
      },
      failureVideoId: {
        title: "Oops!<br/>Something went wrong!",
        subtitle:
          "Unfortunately, your identity could not be confirmed.<br/> Because of this, please print the contract you downloaded earlier and send it duly signed to: <br/><br/><b>Vorsorgestiftung Cornèr Dritte Säule<br/>c/o Cornèr Bank AG<br/>Via Canova 16<br/>6901 Lugano<br/>Switzerland</b>",
      },
      underageNotAllowed: {
        title: "Unfortunately, it is not possible to process your request",
        subtitle:
          "This product is currently only available for persons aged 18 and older.",
      },
      chResidenceRequired: {
        title: "Unfortunately, it is not possible to process your request",
        subtitle: "This product is currently only available in Switzerland.",
      },
      taxResidenceMustBeCH: {
        title: "Unfortunately, it is not possible to process your request",
        subtitle: "This product is currently only available in Switzerland.",
      },
      exsclusiveOwnershipRequired: {
        title: "Unfortunately, it is not possible to process your request",
        subtitle:
          "For the purchase of this product, you must be the sole beneficial owner of the funds.",
      },
      usNotAllowed: {
        title: "Unfortunately, we cannot process your request",
        subtitle:
          "This product is not available to persons who meet the definition as «US Person».",
      },
      missingData: {
        title: "Unfortunately, it is not possible to process your request",
        subtitle:
          "As some information is missing, we cannot process your request.<br/><br/>",
      },
    },
  },
  errors: {
    input: {
      invalidPattern: "Invalid format",
      minLength: "At least {{min}} characters needed",
      maxLength: "A maximum of {{max}} characters are allowed",
      minPhoneLength: "The telephone number must have at least {{min}} digits.",
      required: "Required field",
      mismatch: "{{fieldName}} mismatch",
      leadingZeroNotAllowed: "The first digit cannot be 0",
    },
  },
  days: [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ],
  captchaDisclaimer:
    "This site is protected by reCAPTCHA and the<br/>Google <0>Privacy Policy</0> and <1> Terms of Service</1> apply.",
  captchaTooLow: {
    title: "Captcha verification failed",
    description: "Please try again",
  },
};
